import type { CategoryUidaAsset } from '../compat/tvpil';
import { queryKeys } from '../queryKeys';

import { fetchChannelCollection } from './queryFunctions';
import { shouldIncludeAdult } from './utils';

export function createChannelCollectionQueryOptions(category: CategoryUidaAsset) {
  return {
    queryKey: queryKeys.channelCollection(category.channels[0], shouldIncludeAdult(category), category.aggregatedKSQL),
    queryFn: () =>
      fetchChannelCollection({
        collectionId: category.channels[0],
        includeAdult: shouldIncludeAdult(category),
        kSql: category.aggregatedKSQL,
      }),
    staleTime: Infinity,
  };
}
